import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@forgeglobal/design-framework';

import TabContent from '@tcs/common/components/atoms/TabContent';
import RepresentativeHeader from '@tcs/client-portal-common/components/organisms/Header/RepresentativeHeader';
import useRecentlyViewedAccounts, {
  recentItemFromRepresentative,
} from '@tcs/client-portal-common/hooks/useRecentlyViewedAccounts';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import useRepresentative from '@tcs/client-portal-common/hooks/useRepresentative';
import { Persona } from '@tcs/client-portal-api/types/Persona';
import AccountsOverview from './AccountsOverview';
import AccountsReports from '@tcs/client-portal-representative/pages/Accounts/AccountsReports';
import { Route } from 'react-router';
import useIsEligibleAccounts from '@tcs/client-portal-common/hooks/useIsEligibleAccounts';
const Representative = () => {
  const {
    claims: { clientPortalIdentity },
  } = useSession();
  const { addRecentItem } = useRecentlyViewedAccounts(clientPortalIdentity);
  const { representativeCode } = useParams();
  const { loading: loadingAccount, data: representative } =
    useRepresentative(representativeCode);
  const { isEligible } = useIsEligibleAccounts(representativeCode);
  useEffect(() => {
    if (loadingAccount || !representative) return;
    addRecentItem(
      recentItemFromRepresentative(representative),
      Persona.Representative
    );
  }, [representativeCode, loadingAccount]);

  return (
    <RepresentativeHeader
      representativeCode={representativeCode}
      loading={loadingAccount}
      tabs={() => (
        <Tabs>
          <Route
            path="*"
            element={
              <TabContent label="Overview" data-test-id="account-overview-tab">
                <AccountsOverview representativeCode={representativeCode} />
              </TabContent>
            }
          />
          {isEligible && (
            <Route
              path="/reports"
              element={
                <TabContent label="Reports" data-test-id="accounts-reports-tab">
                  <AccountsReports representativeCode={representativeCode} />
                </TabContent>
              }
            />
          )}
        </Tabs>
      )}
    />
  );
};

export default Representative;
